// extracted by mini-css-extract-plugin
export default {"menu":"GridActionRowTagsContextMenu_menu__yFQQj","tag":"GridActionRowTagsContextMenu_tag__cQKBm","selected":"GridActionRowTagsContextMenu_selected__6KryY"};